<template>
<table class="table" ref="table">
  <slot></slot>
</table>
</template>

<script>
// import 'jszip';
// import 'pdfmake/build/pdfmake';
// import 'pdfmake/build/vfs_fonts';
// import 'datatables.net-bs4';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
// import 'datatables.net-buttons-bs4';
// import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
// import 'datatables.net-buttons/js/buttons.html5';
// import 'datatables.net-fixedcolumns-bs4';
// import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css';
// import 'datatables.net-fixedheader-bs4';
// import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css';
// import 'datatables.net-responsive-bs4';
// import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
// import 'datatables.net-scroller-bs4';
// import 'datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css';

const DATATABLES_EVENT_NAMESPACE = 'dt';

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    events: {
      type: [String, Array],
      default: '',
    },
  },
  mounted() {
    this.initTable();
  },
  beforeUpdate() {
    this.destroy();
  },
  updated() {
    this.initTable();
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    initTable() {
      const $table = $(this.$refs.table);
      const { events } = this;
      if (typeof events === 'string') {
        this.bindEvent($table, events);
      } else if (Array.isArray(events)) {
        events.forEach((event) => {
          this.bindEvent($table, event);
        });
      }
      this.table = $table.DataTable(this.options);
    },
    bindEvent($table, event) {
      const realEvent = `${event}.${DATATABLES_EVENT_NAMESPACE}`;
      $table.on(realEvent, (...args) => {
        this.$emit(event, ...args);
      });
      let { eventsBound } = this;
      if (!eventsBound) {
        eventsBound = [];
        this.eventsBound = eventsBound;
      }
      eventsBound.push(realEvent);
    },
    destroy() {
      const { eventsBound, table } = this;
      if (eventsBound) {
        table.off(eventsBound.join(' '));
      }
      table.destroy();
    },
    getDTApi() {
      return this.table;
    },
  },
};
</script>

<style lang="scss">
  $primary-color: var(--v-primary-base);
  $primary-color-dark: var(--v-primary-darken1);
  .page-link {
    color: $primary-color;
    &:hover {
      color: $primary-color-dark;
    }
  }
  .page-item.active{
    .page-link {
      background-color: $primary-color;
      border-color: $primary-color;
    }
  }
</style>
